import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartRequestLeadAlertsResponse } from "../models/partRequests/IPartRequest";
import apiConfig from "../utils/apiConfig";

/**
 * Live part requests the car on a lead may be able to supply. The API answers with an empty list
 * when the customer doesn't have Part Requests, so the alert simply doesn't show.
 */
export default function usePartRequestLeadAlerts(leadId?: string, componentName = "usePartRequestLeadAlerts") {
  const { get } = useApiHelper(apiConfig(componentName));

  return useQuery({
    queryKey: ["partRequestLeadAlerts", leadId],
    queryFn: () => get<IPartRequestLeadAlertsResponse>(`/partrequest/for-lead/${leadId}`),
    enabled: !!leadId,
    staleTime: 1000 * 60,
  });
}
